import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SelectInputProps } from "@/types";
import { useVModel } from "@/hooks";


/**
 * A generic select input.
 */
const __default__ = {
  name: "SelectInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    options: {},
    optionValue: { type: [String, Function] },
    optionLabel: { type: [String, Function] },
    optionToValue: { type: Boolean },
    outlined: { type: Boolean },
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "new-value"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const model = useVModel(props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    filled: !props.outlined,
    outlined: props.outlined,
    disable: props.disabled,
    label: props.label,
    options: props.options,
    "option-value": props.optionValue,
    "option-label": props.optionLabel,
    "map-options": props.optionToValue,
    "emit-value": props.optionToValue,
    class: "text-ellipsis",
    onNewValue: _cache[1] || (_cache[1] = ($event: any) => (emit('new-value', $event)))
  }, {
    prepend: _withCtx(() => [
      _renderSlot(_ctx.$slots, "prepend")
    ]),
    _: 3
  }, 8, ["modelValue", "filled", "outlined", "disable", "label", "options", "option-value", "option-label", "map-options", "emit-value"]))
}
}

})